// @ts-nocheck
import React, { useState } from 'react';

//import {parseDiff, Diff, Hunk} from 'react-diff-view';
import {Diff, Hunk, Decoration, parseDiff, FileData, HunkData, ViewType} from 'react-diff-view';
import {diffLines, formatLines} from 'unidiff';
import 'react-diff-view/style/index.css';

import {
  Paper,
  Chip,
  ButtonGroup,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  Stack,
} from '@mui/material';
import notify from 'devextreme/ui/notify';
import { JsonViewer } from '@textea/json-viewer'
import {
  Link as RouterLink,
  MemoryRouter,
} from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';

//import Button from 'react-bootstrap/Button';
//import Col from 'react-bootstrap/Col';
//import Form from 'react-bootstrap/Form';
//import Alert from 'react-bootstrap/Alert';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { Link, Navigate, useParams } from "react-router-dom";
import Form, {
  EmptyItem,
  GroupItem,
  Label,
  SimpleItem,
  CompareRule,
  EmailRule,
  PatternRule,
  RangeRule,
  RequiredRule,
  StringLengthRule,
} from 'devextreme-react/form';
import 'devextreme-react/text-area';
import 'devextreme-react/select-box';

import moment from 'moment';

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';

import TextBox from 'devextreme-react/text-box';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// ************************************************************
// ************************************************************
// ************************************************************

export const EcuCalibComponentWrapper = (props) => {
  const { calib_id } = useParams()
  const { comp_calib_id } = useParams()
  const navigate = useNavigate()
  return <EcuCalib
    calib_id={calib_id}
    comp_calib_id={comp_calib_id}
    navigate={navigate}
    {...props}
  />
}

const FormattedNumDateTime = (props) => {
  const data = new Date(props.dataString)
  const opzioniFormattazione = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }
  const formatoItaliano = new Intl.DateTimeFormat('it-IT', opzioniFormattazione)
  const dataFormattata = formatoItaliano.format(data)
  return (
    <>
      {dataFormattata}
    </>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  // https://stackoverflow.com/questions/41928567/div-cannot-appear-as-a-descendant-of-p
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'} variant={'body2'}>{children}</Typography>
        </Box>
      )}
    </div>
  )
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

function download(content, fileName, contentType) {
  var a = document.createElement("a");
  var file = new Blob([content], { type: contentType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}

function get_calib_xml(calib) {
  var t = ""
  t += "<?xml version=\"1.0\"?>\r\n"
  t += "<Document xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns:xsd=\"http://www.w3.org/2001/XMLSchema\">\r\n"
  t += "  <CalibrationItems>\r\n"
  var items = calib.CalibrationItems.map(x => {
    var t = ""
    t += "    <CalibrationItem>\r\n"
    t += "      <Name>" + x.Name + "</Name>\r\n"
    t += "      <PhysValues>\r\n"
    x.PhysValues.forEach(v => t += "        <string>" + v + "</string>\r\n")
    t += "      </PhysValues>\r\n"
    if (x.Unit != "")
      t += "      <Unit>" + x.Unit + "</Unit>\r\n"
    else
      t += "      <Unit />\r\n"
    t += "    </CalibrationItem>\r\n"
    return t
  })
  t += items.join('')
  t += "  </CalibrationItems>\r\n"
  t += "  <Time>" + calib.Time + "</Time>\r\n"
  t += "  <WorkspaceFileName>" + calib.WorkspaceFileName + "</WorkspaceFileName>\r\n"
  t += "  <WorkspaceRevision>" + calib.WorkspaceRevision + "</WorkspaceRevision>\r\n"
  t += "  <ExpectedFirmwareVersion>" + calib.ExpectedFirmwareVersion + "</ExpectedFirmwareVersion>\r\n"
  t += "  <FirmwareVersionRead>" + calib.FirmwareVersionRead + "</FirmwareVersionRead>\r\n"
  t += "</Document>"
  return t
}

class EcuCalibDetatils extends React.Component {
  // dalle props: 
  // calib_id
  // calib_content
  // calib_insert_date
  // selected_tab_index
  // handle_tab_changed
  constructor(props) {
    super(props)
    // this.state = {      
    // }
  }
  render() {
    var calib_name = this.props.calib_content.CalibrationItems.find(item => item.Name === "CalibrationName")?.PhysValues[0]
    var system_type = this.props.calib_content.CalibrationItems.find(item => item.Name === "__PC.SystemType")?.PhysValues[0]

    console.log(calib_name)
    console.log(system_type)

    var idx_items = 0
    return (
      <>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={this.props.selected_tab_index}
            onChange={(e, newValue) => {
              this.props.handle_tab_changed(this.props.calib_id, newValue)
            }}
            aria-label="tabs">
            <Tab
              label="INFO"
              {...a11yProps(0)} />
            <Tab
              label="PARAMETER LIST"
              disabled={false}
              {...a11yProps(1)} />
            <Tab
              label="JSON VIEW"
              disabled={false}
              {...a11yProps(2)} />
            <Tab
              label="DOWNLOAD"
              disabled={false}
              {...a11yProps(3)} />
          </Tabs>
        </Box>
        <TabPanel value={this.props.selected_tab_index} index={0}>
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                <TableRow key={0}>
                  <TableCell>Firmware version used</TableCell>
                  <TableCell><b>{this.props.calib_content.FirmwareVersionRead}</b></TableCell>
                </TableRow>
                <TableRow key={1}>
                  <TableCell>Workspace name</TableCell>
                  <TableCell><b>{this.props.calib_content.WorkspaceFileName}</b></TableCell>
                </TableRow>
                <TableRow key={2}>
                  <TableCell>Workspace revision</TableCell>
                  <TableCell><b>{this.props.calib_content.WorkspaceRevision}</b></TableCell>
                </TableRow>
                <TableRow key={3}>
                  <TableCell>Insert date</TableCell>
                  <TableCell><b><FormattedNumDateTime dataString={this.props.calib_insert_date} /></b></TableCell>
                </TableRow>
                <TableRow key={4}>
                  <TableCell>Name</TableCell>
                  <TableCell><b>{calib_name}</b></TableCell>
                </TableRow>
                <TableRow key={5}>
                  <TableCell>System type</TableCell>
                  <TableCell><b>{system_type}</b></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={this.props.selected_tab_index} index={1}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.calib_content.CalibrationItems.map(item => {
                  return (
                    <TableRow key={idx_items++}>
                      <TableCell style={{ fontFamily: 'monospace' }}>
                        {item.Name}
                      </TableCell>
                      <TableCell>
                        <b style={{ fontFamily: 'monospace' }}>
                          {item.PhysValues.map((p, idx) => (
                            <React.Fragment key={idx}>{p} </React.Fragment>
                          ))}
                        </b>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={this.props.selected_tab_index} index={2}>
          <JsonViewer
            value={this.props.calib_content.CalibrationItems}
            rootName={false}
            indentWidth={4}
            enableClipboard={true}
            displayDataTypes={false}
            maxDisplayLength={30}
            groupArraysAfterLength={100}
          />
        </TabPanel>
        <TabPanel value={this.props.selected_tab_index} index={3}>
          <Stack spacing={2} direction="row">

            <Button
              variant="contained"
              onClick={() => {
                var txt = get_calib_txt(this.props.calib_content)
                download(txt, 'cal-' + this.props.calib_id + '.txt', 'text/plain')
              }}>TXT</Button>

            <Button
              variant="contained"
              onClick={() => {
                var txt = JSON.stringify(this.props.calib_content.CalibrationItems, null, 2)
                download(txt, 'cal-' + this.props.calib_id + '.json', 'application/json');
              }}>JSON</Button>

            <Button
              variant="contained"
              onClick={() => {
                AuthService.getEcuCalib(this.props.calib_id, 1).then(data => {
                  if (data.is_valid) {
                    const b64toArray = (base64) => {
                      var raw = window.atob(base64)
                      var array = new Uint8Array(new ArrayBuffer(raw.length))
                      var i
                      for (i = 0; i < raw.length; i++)
                        array[i] = raw.charCodeAt(i)
                      return array.buffer;
                    }
                    var zip_data = b64toArray(data.value)
                    download(zip_data, 'cal-' + this.props.calib_id + '.ccal', 'application/octet-stream');
                  }
                })
              }}>CCAL</Button>

            <Button
              variant="contained"
              onClick={() => {
                var txt = get_calib_xml(this.props.calib_content)
                download(txt, 'cal-' + this.props.calib_id + '.ccal-xml', 'text/plain');
              }}>CCAL-XML</Button>

          </Stack>
        </TabPanel>
      </>
    )
  }
}

const EMPTY_HUNKS = [];

function get_calib_txt(content) {
  var items = content.CalibrationItems.map(x => {
    var t = x.Name
    if (x.Unit !== "") t += " [" + x.Unit + "]"
    t += ":"
    x.PhysValues.forEach(v => t += " " + v)
    return t
  })
  var txt = items.join("\n")
  return txt
}
const renderHunk = (hunk: HunkData) => (
  <>
      <Decoration>
        {null}
        {hunk.content}
      </Decoration>
      <Hunk key={hunk.content} hunk={hunk} />
  </>
)
class FormattedDiff extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      load_error_message: "",
      diff_type: undefined,
      diff_hunks: undefined,
    }
  }  
  componentDidMount() {
    var txt1 = get_calib_txt(this.props.sec_calib_content)
    var txt2 = get_calib_txt(this.props.ref_calib_content)
    const diffText = formatLines(diffLines(txt1, txt2), {context: 3});  
    const [diff] = parseDiff(diffText, {nearbySequences: 'zip'});
    //console.log(diff)
    this.setState({
      diff_type: diff.type,
      diff_hunks: diff.hunks,
    })
  }
  
  render() {
    return (
      <>
        <Diff 
          viewType="split" 
          diffType={this.state.diff_type} 
          hunks={this.state.diff_hunks || EMPTY_HUNKS}>
          {/* {hunks =>
              hunks.map(hunk => (
                  <Hunk key={hunk.content} hunk={hunk} />
              ))
          } */}
          {(hunks) => hunks.map(renderHunk)}
        </Diff>
      </>
    )

  }
}

export class EcuCalib extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />

    var isReseller = false
    var isAdmin = false
    if (this.props.authStatus.user.is_admin) {
      // ok
      var isAdmin = true
    } else if (this.props.authStatus.user.is_reseller) {
      // ok
      isReseller = true
    } else {
      return <UserAuthRequired notallowed />
    }
    
    return <EcuCalibBasic
      calib_id={this.props.calib_id}
      comp_calib_id={this.props.comp_calib_id}
      />
  }
}

export class EcuCalibBasic extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ref_calib_id: this.props.calib_id,
      ref_loading: this.props.calib_id !== undefined,
      ref_calib_content: undefined, 
      ref_calib_insert_date: undefined,
      ref_selected_tab_index: 0,

      sec_calib_id: this.props.comp_calib_id,
      sec_loading: this.props.comp_calib_id !== undefined,
      sec_calib_content: undefined,
      sec_calib_insert_date: undefined,
      sec_selected_tab_index: 0,

      main_selected_tab_index: (this.props.calib_id !== undefined && this.props.comp_calib_id !== undefined) ? 2 : 0,

      load_error_message: "",
    }
  }
  componentDidMount() {
    console.log("MOUNT: this.props.calib_id", this.props.calib_id)
    console.log("MOUNT: this.props.comp_calib_id", this.props.comp_calib_id)
    this.loadCalibs()
  }
  componentDidUpdate() {
    console.log("UPDATE: this.props.calib_id", this.props.calib_id)
    console.log("UPDATE: this.props.comp_calib_id", this.props.comp_calib_id)
    if (this.state.ref_calib_id !== this.props.calib_id) {
      this.loadCalibs()
    } else if (this.state.sec_calib_id !== this.props.comp_calib_id) {
      this.loadCalibs()
    }
  }
  loadCalibs() {
    this.setState({
      ref_loading: this.state.ref_calib_id !== undefined,
      ref_calib_content: undefined,
      ref_calib_insert_date: undefined,

      sec_loading: this.state.sec_calib_id !== undefined,
      sec_calib_content: undefined,
      sec_calib_insert_date: undefined,

      load_error_message: "",
    })

    if (this.state.ref_calib_id !== undefined) {
      AuthService.getEcuCalib(this.state.ref_calib_id, 0).then(data => {
        if (data.is_valid) {
          // console.log("CalibrationItems", JSON.parse(data.value))
          // console.log("insert_date,", data.insert_date)
          this.setState({
            ref_calib_content: JSON.parse(data.value),
            ref_calib_insert_date: data.insert_date,
            ref_loading: false,          
          })
        } else {
          console.log(data.message)
          this.setState({
            ref_loading: false,
            load_error_message: data.message,
          })
        }
      }).catch(e => {
        console.log(e)
        this.setState({
          ref_loading: false,
          load_error_message: e,
        })
      })
    }

    if (this.state.sec_calib_id !== undefined) {
      AuthService.getEcuCalib(this.state.sec_calib_id, 0).then(data => {
        if (data.is_valid) {
          // console.log("CalibrationItems", JSON.parse(data.value))
          // console.log("insert_date,", data.insert_date)
          this.setState({
            sec_calib_content: JSON.parse(data.value),
            sec_calib_insert_date: data.insert_date,
            sec_loading: false,          
          })
        } else {
          console.log(data.message)
          this.setState({
            sec_loading: false,
            load_error_message: data.message,
          })
        }
      }).catch(e => {
        console.log(e)
        this.setState({
          sec_loading: false,
          load_error_message: e,
        })
      })
    }
  }
  // funzione per visualizzare un messaggio che poi scompare in automatico
  notifySomething(message, type = "success") {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }
  handle_tab_changed(calib_id, tab_index) {
    console.log("calib_id", calib_id)
    console.log("tab_value", tab_index)
    if (this.state.ref_calib_id === calib_id) {
      this.setState({
        ref_selected_tab_index: tab_index
      })
    } else {
      this.setState({
        sec_selected_tab_index: tab_index
      })
    }
  }
  render() {
    if (this.state.ref_loading || this.state.sec_loading) return <LoadingSpinner />
    if (this.state.load_error_message !== "") return <>{this.state.load_error_message}</>
    var idx_tab = 0
    var idx_prop = 0
    return (
      <>
        <div>
          {/* <div className="container-sm"> */}
            {/* <Box sx={{ width: '100%' }}> */}
              
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  textColor="secondary"
                  indicatorColor="secondary"
                  value={this.state.main_selected_tab_index}
                  onChange={(e, newValue) => {
                    this.setState({
                      main_selected_tab_index: newValue,
                    })
                  }}
                  aria-label="tabs">

                  {(this.state.sec_calib_content !== undefined) &&
                    <Tab
                      label={"CAL ID: " + this.state.sec_calib_id}
                      // disabled={this.state.ref_calib_content === undefined}
                      {...a11yProps(idx_prop++)} />
                  }

                  <Tab
                    label={"CAL ID: " + this.state.ref_calib_id}
                    {...a11yProps(idx_prop++)} />
                                    
                  {(this.state.sec_calib_content !== undefined) &&
                    <Tab
                      label="CAL DIFFERENCES"
                      {...a11yProps(idx_prop++)} />
                  }
                </Tabs>
              </Box>

              {(this.state.sec_calib_content !== undefined) && <TabPanel value={this.state.main_selected_tab_index} index={idx_tab++}>
                {/* <Chip label={"SEC CAL ID: " + this.state.sec_calib_id} color="info" /> */}
                <EcuCalibDetatils
                  calib_id={this.state.sec_calib_id}
                  calib_content={this.state.sec_calib_content}
                  calib_insert_date={this.state.sec_calib_insert_date}
                  selected_tab_index={this.state.sec_selected_tab_index}
                  handle_tab_changed={this.handle_tab_changed.bind(this)}
                  />
              </TabPanel>}

              <TabPanel value={this.state.main_selected_tab_index} index={idx_tab++}>
                {/* <Chip label={"REF CAL ID: " + this.state.ref_calib_id} color="info" /> */}
                <EcuCalibDetatils
                  calib_id={this.state.ref_calib_id}
                  calib_content={this.state.ref_calib_content}
                  calib_insert_date={this.state.ref_calib_insert_date}
                  selected_tab_index={this.state.ref_selected_tab_index}
                  handle_tab_changed={this.handle_tab_changed.bind(this)}
                  />
              </TabPanel>

              {(this.state.sec_calib_content !== undefined) && <TabPanel value={this.state.main_selected_tab_index} index={idx_tab++}>
                <Box>
                  <FormattedDiff 
                    ref_calib_content={this.state.ref_calib_content}
                    sec_calib_content={this.state.sec_calib_content}
                  />
                </Box>
              </TabPanel>}

            {/* </Box> */}
          {/* </div> */}

        </div>
      </>
    )
  }
}
